import React, { useEffect, useState } from 'react';
import FormModal from '../../shared/components/custom/FormModal';
import IconPicker from './IconPicker';
import { partial } from '../../util/translation/translation';

const p = partial('appLayout');
const s = partial('shared');

// Change the icon of one of the app's own More menu rows ('' = its default)
const MoreIconModal = ({ isOpen, item, onClose, onSave }) => {
  const [icon, setIcon] = useState('');

  useEffect(() => {
    setIcon(item?.icon || '');
  }, [item]);

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={item?.name || p('iconTitle')}
      subtitle={p('iconHint')}
    >
      <div className="qm-body">
        <IconPicker
          value={icon}
          onChange={setIcon}
          ariaLabel={p('iconField')}
        />
      </div>
      <div className="qm-footer">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm mb-0"
          onClick={onClose}
        >
          {p('cancel')}
        </button>
        <button
          type="button"
          className="btn btn-primary btn-sm mb-0"
          onClick={() => onSave(icon)}
        >
          {s('update')}
        </button>
      </div>
    </FormModal>
  );
};

export default MoreIconModal;
